import React, { FC } from 'react';
import { t } from 'i18next';
import IndividualReportGroupsDistribution from './IndividualReportGroupsDistribution/IndividualReportGroupsDistribution';
import IndividualReportProgressBar from './IndividualReportProgressBar/IndividualReportProgressBar';
import {
  ActionCardButton,
  ContentCont,
  InfoIcon,
  ProgressCont,
  Score,
  Title,
} from './IndividualReportSummaryCard.styles';
import { EScore, EScoreRating } from '../../services/individualReport';

interface IIndividualReportSummaryCard {
  distribution: number[];
  mode: 'results' | 'group';
  score: EScore;
  score_rating: EScoreRating;
  title: string;
  code: string;
  onClick?: () => void;
}

const IndividualReportSummaryCard: FC<IIndividualReportSummaryCard> = ({
  distribution,
  mode,
  score,
  score_rating,
  title,
  code,
  onClick,
}) => (
  <ActionCardButton id="ActionCardButton" {...{ onClick }}>
    <ContentCont id="ContentCont">
      <InfoIcon id="InfoIcon" />
      <ContentCont id="ContentCont">
        <Title id="Title">{title}</Title>
        <Score id="Score">{t(`results.report.predictiveStates.score.${score}`)}</Score>
      </ContentCont>
    </ContentCont>
    <ProgressCont id="ProgressCont">
      {mode === 'results' ? <IndividualReportProgressBar {...{ score, score_rating }} /> : null}
      {mode === 'group' ? (
        <IndividualReportGroupsDistribution {...{ distribution, score_rating, code }} />
      ) : null}
    </ProgressCont>
  </ActionCardButton>
);

export default IndividualReportSummaryCard;
